export const LOAD_DIVES_SUCCESS = 'LOAD_DIVES_SUCCESS';

export const LOAD_DIVE_DATA_SUCCESS = 'LOAD_DIVE_DATA_SUCCESS';

export const LOAD_SHARED_DIVES_SUCCESS = 'LOAD_SHARED_DIVES_SUCCESS';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/actionTypes.ts